'use client';
import { useState, useEffect } from 'react';
import Footer from './Footer';
import { getCourses } from "../../lib/getCourses";

const FooterWrapper = () => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    getCourses()
      .then(data => setCourses(data || []))
      .catch(() => setCourses([]));
  }, []);

  return <Footer courses={courses} />;
}

export default FooterWrapper;